

export const Footer = () => {
  return (
    
<footer className="bg-primary text-white text-center py-3">
    <div className="container">
        <p className="mb-0">© 2026 Each-one-Tech-one. All rights reserved.</p>
        <p className="mb-0">
            Follow us on 
            <a href="https://instagram.com/eachonetechone/" className="text-white mx-2">Instagram</a> | 
            <a href="https://x.com/EachTechNews" className="text-white mx-2">X</a> | 
              </p>
    </div>
</footer>
 
)
}
